var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-layout"},[_c('div',{staticClass:"add-wrap"},[_c('addcon',{attrs:{"addData":_vm.addData},on:{"addinfo":_vm.addinfo}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }